import PropTypes from '../../_utils/props-types';
export const languageProps = () => ({
    prefixCls: PropTypes.string,
    dataSource: Array,
    data: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    categorySource: Array,
    category: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    createCategory: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    updateCategory: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    deleteCategory: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    defaultCategory: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'PUT',
                params: {},
                callback: null
            };
        }
    },
    checkCategoryExist: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    createLanguage: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    batchCreateLanguage: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    updateLanguage: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    deleteLanguage: {
        type: Object,
        required: true,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    searchLanguage: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    checkLanguageExist: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    translate: {
        type: Object,
        default: () => {
            return {
                url: '',
                appid: '',
                key: ''
            };
        }
    },
    paginationLocale: PropTypes.any
});
